<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Time Input</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <ng-container *ngIf="isBrowser;else noJsContent">
    <form [formGroup]="formElement" (ngSubmit)="submit()">
      <h2>Default case</h2>
      <maced-time-input timeInputId="timeInputId" name="timeInputId"
        formControlName="inputVal" label="Label" srOnlyTimeLabel="Start Time- " [srOnlyTime]="true">
        <ng-container ngProjectAs="[message]">
          <div class="c-time-form__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-time-input>
      <h3>Disabled case</h3>
      <maced-time-input timeInputId="timeInputId2" name="timeInputId2" formControlName="timeDisableInput"
        [disabled]="true" label="Label" [srOnlyTime]="false">
        <ng-container ngProjectAs="[message]">
          <div class="c-time-form__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-time-input>
      <h2>Invalid Empty case</h2>
      <maced-time-input timeInputId="timeInputId3" [required]="true" name="timeInputId3"
        formControlName="timeErrorInput" label="Label" [srOnlyTime]="false"
        [hasError]="(formElement.controls.timeErrorInput.touched || submitted) && !!formElement.controls.timeErrorInput.errors">
        <ng-container ngProjectAs="[message]">
          <div class="c-time-form__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-time-input>
      <span role="alert" class="c-input-group__error"
        *ngIf="(formElement.controls.timeErrorInput.touched || submitted) && formElement.controls.timeErrorInput.errors?.required">
        This field is required
      </span>
      <h2>Error case</h2>
      <maced-time-input [time]="time4" [required]="true" timeInputId="timeInputId4" name="timeInputId4"
        formControlName="timeErrorInput1" [srOnlyTime]="false"
        [hasError]="(formElement.controls.timeErrorInput1.touched || submitted) && !!formElement.controls.timeErrorInput1.errors"
        label="Label">
        <ng-container ngProjectAs="[message]">
          <div class="c-time-form__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-time-input>
      <span role="alert" class="c-input-group__error"
        *ngIf="(formElement.controls.timeErrorInput1.touched || submitted) && formElement.controls.timeErrorInput1.errors?.required">
        This field is required
      </span>
      <span role="alert" class="c-input-group__error"
        *ngIf="(formElement.controls.timeErrorInput1.touched || submitted) && formElement.controls.timeErrorInput1.errors?.minError">
        This should have minimum value hours:{{minTime4.hours}} and minutes:{{minTime4.minutes}}
      </span>
      <button type="submit">Submit</button>
    </form>
  </ng-container>

  <ng-template #noJsContent>
    <h2>NoJs case</h2>
    <form action="/time-input" method="get">
      <maced-time-input timeInputId="timeInputId4" [required]="true" name="noJsInput" [ngModel]="time2" [time]="time2">
        <ng-container ngProjectAs="[message]" label="Label">
          <div class="c-time-form__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-time-input>
      <br>
      <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
    </form>
    <div>
      <h3>Result</h3>
      <div>
        Input value:-&nbsp;
        {{ time2.hours+':'+time2.minutes }}
      </div>
    </div>
  </ng-template>
</div>